// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase';

let config = {
    apiKey: 'AIzaSyCDOqiTg-3Y7yt4Uk9USiDuOD2dtTv6XMM',
    // authDomain: 'qlist-70c1e.firebaseapp.com',
    authDomain: 'app.thecuelist.com',
    databaseURL: 'https://qlist-70c1e.firebaseio.com',
    projectId: 'qlist-70c1e',
    storageBucket: 'qlist-70c1e.appspot.com',
    messagingSenderId: '316729066442',
};

// const host = document.URL.split('/')[2];

// if (host === "localhost:8080") {
//     config = {
//         apiKey: "AIzaSyBKiU2cD6LEJzB4B19eHmh-sVkUaCDeMuA",
//         authDomain: "sorjak-151720.firebaseapp.com",
//         databaseURL: "https://sorjak-151720.firebaseio.com",
//         projectId: "sorjak-151720",
//         storageBucket: "sorjak-151720.appspot.com",
//         messagingSenderId: "168356815887"
//     };
// }

firebase.initializeApp(config);

import VueResource from 'vue-resource';

Vue.use(VueResource);

// View Material Module
import VueMaterial from 'vue-material'
// View Material CSS
import 'vue-material/dist/vue-material.css'
import './styles/extra.scss'
import App from './App';
import router from './router';
import store from './lib/vuex/Store'
// import vueDragResize from 'vue-draggable-resizable';

// Vue.component('vue-draggable-resizable', vueDragResize);

Vue.config.productionTip = false;

let app;

Vue.use(VueMaterial);
Vue.material.registerTheme({
    default: {
        primary: {
            color: '#0d2744',
            hue: 800
        }
    },
    'show-mode': {
        background: {
            color: 'grey',
            hue: 800
        },
        textColor: 'white'
    },
    white: {
        textColor: 'black',
        background: 'white'
    }
});

firebase.auth().onAuthStateChanged(function(user) {
    app = new Vue({
        el: '#app',
        store,
        router,
        template: '<App/>',
        components: { App },
    });
});



// WEBPACK FOOTER //
// ./sample/main.js